import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './LoginModal.css';
import log from '../../Assets/log.svg';
import desk from '../../Assets/register.svg';
import { useState } from 'react';
import SignInForm from './SignInForm';
import SignUpForm from './SignUpForm';
import toast from 'react-hot-toast';
import { SET_USER, useAppContext } from '../../context';

const Form = () => {
  const { dispatch } = useAppContext();
  const [isSignUp, setSignUp] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  let { from } = location.state || { from: { pathname: "/dashboard" } };

  const handleResponse = (res) => {
    if (res.error) {
      toast.error(res.error);
      return;
    }

    dispatch({ type: SET_USER, payload: res });

    toast.success('Successfully Logged In!');

    if (res.role === "admin") {
      navigate("/dashboard");
    } else {
      navigate(from.pathname || "/");
    }
  };

  return (
    <div className={`${isSignUp ? "fContainer sign-up-mode" : "fContainer"}`}>

      <div className="forms-container">
        <div className="signIn-singUp">
          <SignInForm handleResponse={handleResponse} />
          <SignUpForm handleResponse={handleResponse} />
        </div>
      </div>

      <div className="panels-container">
        <div className="panel left-panel">
          <div className="content">
            <h3>New here?</h3>
            <p>Create your NextGen Nexus account and access your dashboard.</p>
            <button className="iBtn transparent" onClick={() => setSignUp(true)}>Sign Up</button>
          </div>
          <img src={log} alt="" className="pImg" />
        </div>

        <div className="panel right-panel">
          <div className="content">
            <h3>One of us?</h3>
            <p>Sign in to continue managing your services and bookings.</p>
            <button className="iBtn transparent" onClick={() => setSignUp(false)}>Sign In</button>
          </div>
          <img src={desk} alt="" className="pImg" />
        </div>
      </div>
    </div>
  );
};

export default Form;